import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance, axiosInstanceAuth } from "../../../Utils/AxiosInstance";
import { revertAll } from "../ResetStateAction";

const initialState = {
  CampaignPopulate: null,
  CampaignHistory: [],
  CampaignHistoryDetails: [],

  AllCampaign: null,
  isSuccess: false,
  message: null,
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  IsLogin: true,
};
export const fetchAllCampaigns = createAsyncThunk("/Campaigns", async () => {
  const response = await axiosInstance.get(`/Campaigns`);
  return response.data;
});
export const fetchCampaignPopulate = createAsyncThunk("/Campaigns/PopulateCompaign", async () => {
  const response = await axiosInstance.get(`/Campaigns/PopulateCompaign`);
  return response.data;
});
export const fetchWaCampaignHistory = createAsyncThunk("/Campaigns/GetWhatsappMessages", async () => {
  const response = await axiosInstanceAuth.get(`/Whatsapp/GetWhatsappMessages?module=CRM`);
  return response.data;
});
export const fetchWaCampaignHistoryDetails = createAsyncThunk("/Campaigns/GetWhatsappMessageDetail", async id => {
  const response = await axiosInstanceAuth.get(`/Whatsapp/GetWhatsappMessageDetail?id=${id}`);
  return response.data;
});
const CampaignsSlice = createSlice({
  name: "CampaignsSlice",
  initialState,
  reducers: {
    CampaignsAdded: {
      reducer(state, action) {
        state.CampaignPopulate?.push(action.payload?.CampaignPopulate?.data?.Data);
      },
    },
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)
      .addCase(fetchCampaignPopulate.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchCampaignPopulate.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload?.Message;
        state.isSuccess = action.payload?.IsSuccess;
        state.CampaignPopulate = action.payload?.Data;
      })
      .addCase(fetchCampaignPopulate.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchAllCampaigns.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchAllCampaigns.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload?.Message;
        state.isSuccess = action.payload?.IsSuccess;
        state.AllCampaign = action.payload?.Data;
      })
      .addCase(fetchAllCampaigns.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchWaCampaignHistory.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchWaCampaignHistory.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload?.Message;
        state.isSuccess = action.payload?.IsSuccess;
        state.CampaignHistory = action.payload?.Data || [];
      })
      .addCase(fetchWaCampaignHistory.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchWaCampaignHistoryDetails.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchWaCampaignHistoryDetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload?.Message;
        state.isSuccess = action.payload?.IsSuccess;
        state.CampaignHistoryDetails = action.payload?.Data || [];
      })
      .addCase(fetchWaCampaignHistoryDetails.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      });
  },
});
export const getCampaignsDetails = state => state.CampaignsSlice;

export const { CampaignsAdded } = CampaignsSlice.actions;

export default CampaignsSlice.reducer;
